import script from "./StudentLinkedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentLinkedPage.vue?vue&type=script&setup=true&lang=js"

import "./StudentLinkedPage.vue?vue&type=style&index=0&id=6372bddd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6372bddd"]])

export default __exports__